export function shareModal() {
    const shareButton = document.querySelector('[data-share-modal]');
    const modal = document.querySelector('[data-modal]');
    const alertModal = document.querySelector('[data-alert-modal]');
    const form = document.querySelector('.question-form form');
    const closebutton = modal.querySelector('.close-modal button');
    const lang = document.documentElement.lang || 'nl';

    if (!shareButton || !modal || !form) return;

    var generatedLink = '';
    var whatsapplink = '';

    shareButton.addEventListener('click', function (e) {
        e.preventDefault();

        var naamField = form.querySelector('[name="input_21"]');
        var voornaamwoordField = form.querySelector('[name="input_22"]:checked') 
            || form.querySelector('select[name="input_22"]')
            || form.querySelector('input[name="input_22"]') 
            || form.querySelector('[name="input_23"]:checked')
            || form.querySelector('select[name="input_23"]')
            || form.querySelector('input[name="input_23"]');

        var naam = naamField ? naamField.value.trim() : '';
        var voornaamwoord = voornaamwoordField ? voornaamwoordField.value.trim() : '';

        if (!naam || !voornaamwoord) {
            if (alertModal) {
                alertModal.classList.add('active');
                document.body.classList.add('popup-open');
            }            
            return;
        }

        if (lang === 'en-US') {
            generatedLink = window.location.origin + '/en/quiz/' + encodeURIComponent(voornaamwoord) + '/level-1/?name=' + encodeURIComponent(naam);
                var message = '✨ *Take the quiz and learn my pronouns!*\n\n'
            + 'Hey! I just created a quiz about my pronouns. '
            + 'Do you want to try it?\n\n'
            + '👉 ' + generatedLink;
        } else {
            generatedLink = window.location.origin + '/quiz/' + encodeURIComponent(voornaamwoord) + '/level-1/?naam=' + encodeURIComponent(naam);
               var message = '✨ *Doe de quiz en leer mijn voornaamwoorden!*\n\n'
            + 'Hey! Ik heb net een quiz gemaakt over mijn voornaamwoorden. '
            + 'Wil jij hem proberen?\n\n'
            + '👉 ' + generatedLink;
        }

        whatsapplink = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(message);
        
        modal.classList.add('active');
        document.body.classList.add('popup-open');
    });

    // Alert modal sluiten
    if (alertModal) {
        var alertClose = alertModal.querySelector('[data-alert-close]');
        if (alertClose) {
            alertClose.addEventListener('click', function () {
                alertModal.classList.remove('active');
                document.body.classList.remove('popup-open');
            });
        }
        alertModal.addEventListener('click', function (e) {
            if (e.target === alertModal) {
                alertModal.classList.remove('active');
                document.body.classList.remove('popup-open');
            }
        });
    }

    // Copy button
    var copyButton = modal.querySelector('[data-copy-link]');
    if (copyButton) {
        copyButton.addEventListener('click', function () {
            navigator.clipboard.writeText(generatedLink).then(function () {
                copyButton.textContent = 'Gekopieerd!';
                setTimeout(function () {
                    copyButton.textContent = 'Copy link';
                }, 2000);
            });
        });
    }

    // Whatsapp button
    var whatsappButton = modal.querySelector('[data-whatsapp-link]');
    if (whatsappButton) {
        whatsappButton.addEventListener('click', function (e) {
            if (!generatedLink) {
                e.preventDefault();
                return;
            }
            whatsappButton.href = whatsapplink;
        });
    }

    function closeClick() {
            modal.classList.remove('active');
            document.body.classList.remove('popup-open');
    }

    closebutton.addEventListener('click', closeClick);
    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeClick();
        }
    });

    modal.addEventListener('click', function (e) {
        if (e.target === modal) {
            closeClick();
        }
    });
}